import { render, staticRenderFns } from "./monitors-screens-a45.vue?vue&type=template&id=601d2e0c&"
import script from "./monitors-screens-a45.vue?vue&type=script&lang=js&"
export * from "./monitors-screens-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports